import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { OutputService } from '../../../infrastructure/services/output.service';
import { Location } from '@angular/common';
import { AlertService, GrowlType } from 'app/infrastructure/services/alert.service';
import { OutputModel, MappingOutputAttribute } from 'app/infrastructure/model/classes/output.classes';

@Component({
    selector: 'sx-mappingList-output',
    templateUrl: './mappingList.output.component.html',
})
export class MappingListOutputComponent implements OnInit {
    systemCode: string;
    outputCode: string;
    output: OutputModel;
    preguntarSiDeseaBorrar = [];
    mappingAttributes: MappingOutputAttribute[] = [];

    // Opciones Tipo Dato
    opciones = [
        'DateTime',
        'Double',
        'String',
        'Decimal',
        'Int32',
        'Int64',
        'Boolean'
    ];

    constructor(
        private aRoute: ActivatedRoute,
        private _router: Router,
        private outputService: OutputService,
        private location: Location,
        private alertService: AlertService,
    ) { }

    ngOnInit() {
        this.aRoute.params.subscribe((params: Params) => {
            this.systemCode = params['codsistema'];
            this.outputCode = params['codoutput'];
            this.output = new OutputModel();
            this.outputService
                .get(this.systemCode, this.outputCode)
                .subscribe(data => {
                    if (!data) {
                        return this._router.navigateByUrl('/soc/404');
                    }
                    if (data.mappingAttribute !== undefined && data.mappingAttribute.length > 0) {
                        this.output = data;
                        this.mappingAttributes = data.mappingAttribute;
                    } else {
                        this.scan();
                    }
                });
        });
    }

    save() {
        this.output.mappingAttribute = this.mappingAttributes;
        this.outputService.edit(this.outputCode, this.systemCode, this.output)
            .then(data => {
                // this.output.rulesIdByCommand = data.rulesIdByCommand;
                this.output = data;

                this.mappingAttributes.forEach(attribute => {
                    const result = data.mappingAttribute.find(a => a.attribute === attribute.attribute);
                    if (result !== undefined) {
                        result.valor = attribute.valor;
                    }
                });

                this.mappingAttributes = data.mappingAttribute;

                this.alertService.showGrowl({
                    type: GrowlType.SUCCESS,
                    body: 'EDITADO_CORRECTAMENTE',
                });
            });
    }

    scan() {
        if (this.output.mappingFrom !== undefined && this.output.mappingFrom !== null && this.output.mappingFrom.length > 0
            && this.output.mappingTo !== undefined && this.output.mappingTo !== null && this.output.mappingTo.length > 0) {
            this.output.outputCode = this.outputCode;
            this.output.systemCode = this.systemCode;
            this.outputService.scanMappingAttributes(this.output.outputCode,
                this.output.systemCode,
                this.output.mappingFrom,
                this.output.mappingTo).subscribe(attributes => {
                    attributes.forEach(scanedAttribute => {
                        const attribute = this.mappingAttributes.find(a => a.attribute === scanedAttribute.attribute);
                        if (attribute !== undefined) {
                            attribute.attribute = scanedAttribute.attribute;
                            attribute.valor = scanedAttribute.valor;
                            attribute.type = scanedAttribute.type;
                        } else {
                            this.mappingAttributes.push(scanedAttribute);
                        }
                    });
                });
        }
    }

    seleccionarOpcion(descripcionDato, tipoDato) {
        const indexMapping = this.mappingAttributes.findIndex(dato => dato.attribute === descripcionDato);
        if (indexMapping > -1) {
            this.mappingAttributes[indexMapping].type = tipoDato;
        }
    }

    clickEdit(attribute) {
        this._router.navigate(['./', attribute.id], { relativeTo: this.aRoute });
    }

    deleteAttribute(attribute: MappingOutputAttribute) {
        this.outputService.deleteAttribute(attribute).
            then(x => {
                this.mappingAttributes = this.mappingAttributes.filter(a => a.id !== attribute.id);
                this.alertService.showGrowl({
                    type: GrowlType.SUCCESS,
                    body: 'OUTPUT_ATTRIUBUTE_DELETE_SUCCESS',
                });
            });
    }

    createNew() {
        this._router.navigate(['./', 'new'], { relativeTo: this.aRoute });
    }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/outputs/mapping/mappingList.output.component.ts